import React, { useEffect, useRef, useState } from "react";
import MisCutVideoMessageBar from "./MixCutVideoMessageBar/MisCutVideoMessageBar";
import Title from "../UIComponents/Title/Title";
import MixCutConfigWrapper from "../UIComponents/MixCutConfigWrapper/MixCutConfigWrapper";
import { IconLoading } from "@arco-design/web-react/icon";
import { getEditingPreview } from "@/services/videoallyis";
import { useParams } from "react-router-dom";
import useMixCutDetailMsg from "@/useStore/mixCutDetail/useMixCutDetailMsg";
import mixCutDetailCheck from "@/useStore/mixCutDetail/mixCutDetailCheck";
import useMixCutDetail from "@/useStore/mixCutDetail/useMixCutDetail";
import Player from "./Player/index";
import { InputNumber, Select, Switch } from "@arco-design/web-react";
import usePreviewConfig from "@/useStore/preview/usePreview";
import { combTimeline } from "@/utils/quick-perm.js";
import previewConfing from "@/stores/quickCutPreview";
import { observer } from "mobx-react";
import clipIdStore from "@/stores/previewStore/clipId";
import usePreviewInfo from "@/useStore/mixCutDetail/usePreviewInfo";
import mixCutDetailStore from "@/stores/mixCutDetailStore";
import ConfigStore from "@/stores/mixedConfig";
import "./PreviewingVideo.less";
import {getScale} from "@/pages/VideoClips/MixCutDetail/VideoCoverConfig/enum";
import useCoverAndBg from "@/useStore/mixCutDetail/useCoverAndBg";
const { Option } = Select;
import QuickStore from '@/stores/quickCutStore'
import QuickCutStore from "@/stores/quickCutStore";
import { toJS } from "mobx";
import {batch_download} from "@/services/createSpace/material";
import {enumRatio} from "@/utils/tool";
const PreviewingVideo = observer((props) => {
  const { activeIndex } = props
  const { handleDecorationChange } = useCoverAndBg();
  const { timer, maxCount } = usePreviewInfo();
  const { id } = useParams();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const { mixCutDetailMsg, handleChangeMixCutDetailMsg } = useMixCutDetailMsg();
  const {
    confirmCaptionsErrorIsEmpty,
    confirmSencesErrorIsEmpty,
    checkJson,
    combSenceMaterials,
  } = mixCutDetailCheck();
  const { background, general } = QuickStore.quickcutData.settings
  const { toIdAndConfigSetSetting } = usePreviewConfig();
  const { handleGetOriginJson } = useMixCutDetail();
  const [loading, setLoading] = useState(false);
  const [timeLine, setTimeLine] = useState<any>(null);
  const [cutResult, setCutResult] = useState(0);
  const [aspectRatio, setAspectRatio] = useState(mixCutDetailMsg?.aspect);
  const playerRef = useRef<any>(true);
  const [bgSelect, setBgSelect] = useState('1');
  const [bgOptions] = useState([
    { label: '纯黑', value: 1 },
    { label: '高斯模糊', value: 2 }
  ])
  const [madiaOptions] = useState([
    { label: '循环使用', value: 1 },
    { label: '不重复使用', value: 2 }
  ])

  useEffect(() => {
    handlePreview()
  }, [previewConfing.version]);

  useEffect(() => {
    handlePreview()
  }, [
    JSON.stringify(QuickCutStore.quickcutData.scenes),
    QuickCutStore.quickcutData.settings.background.enable_blur,
    JSON.stringify(QuickCutStore.previewFilter),
    JSON.stringify(QuickStore.previewTexts),
    QuickStore.quickcutData.settings.copy.show_subtitle
  ]);

  // 预览配置
  const handlePreview = () => {
    setTimeLine({
      timeline: combTimeline(
        previewConfing.getMaterial(QuickCutStore.quickcutData.global ? undefined : activeIndex),
      ),
    });
  }
  useEffect(() => {
    handlePreview()
  }, [toJS(QuickCutStore.quickcutData.settings.video_template?.length), activeIndex])
  const parseJsonToTimeLine = async () => {
    checkJson();
    const result = combSenceMaterials(handleGetOriginJson());
    setCutResult(result);
    if (confirmCaptionsErrorIsEmpty() && confirmSencesErrorIsEmpty()) {
      try {
        setLoading(true);
        const result = await getEditingPreview({
          project_id: Number(mixCutDetailMsg.project_id),
          session_id: Number(id),
          data: JSON.stringify(handleGetOriginJson()),
        });
        console.log(result.timeline, "result.timeline");
        setTimeLine(JSON.parse(result.timeline));
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    }
  };
  const changeRatio = (e: any) => {
    console.log(e, 'e')
    setAspectRatio(e);
    handleChangeMixCutDetailMsg({ ...mixCutDetailMsg, aspect: e });
    clipIdStore.setClipId(null);
    if (ConfigStore.global_settings.enabled && ConfigStore.global_settings.decorations?.length > 0) {
      ConfigStore.global_settings.decorations.map((item) => {
        item.settings.height = getScale(item.settings.real_width, item.settings.real_height, e);
        return item;
      });
    }
    handleDecorationChange(ConfigStore.global_settings.decorations)
  };

  const drawTestLines = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // 清除画布
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // 设置测试线条样式
    ctx.strokeStyle = '#ff0000';
    ctx.lineWidth = 1;
    ctx.globalAlpha = 1.0;
    ctx.setLineDash([5, 5]);

    // 获取容器宽度和高度
    const containerWidth = 360; // 固定宽度为360px
    const containerHeight = 640; // 固定高度为640px

    // 绘制左侧辅助线（距离左边缘25px）
    ctx.beginPath();
    ctx.moveTo(25, 0);
    ctx.lineTo(25, containerHeight);
    ctx.stroke();

    // 绘制右侧辅助线（距离右边缘25px）
    ctx.beginPath();
    ctx.moveTo(containerWidth - 25, 0);
    ctx.lineTo(containerWidth - 25, containerHeight);
    ctx.stroke();

  };

  // 初始化canvas并绘制辅助线，同时监听窗口大小变化
  useEffect(() => {
    // 初始化canvas尺寸
    if (canvasRef.current) {
      canvasRef.current.width = enumRatio(aspectRatio).w
      canvasRef.current.height = enumRatio(aspectRatio).h;
      // 直接调用函数绘制辅助线
      drawTestLines();
    }

    // 监听窗口大小变化，重新绘制辅助线
    const handleResize = () => {
      if (canvasRef.current) {
        canvasRef.current.width = enumRatio(aspectRatio).w;
        canvasRef.current.height = enumRatio(aspectRatio).h;
        drawTestLines();
      }
    };

    window.addEventListener('resize', handleResize);

    // 清理函数
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [aspectRatio]);

  return (
    <MixCutConfigWrapper
      style={{
        boxSizing: "border-box",
        width: 400,
        borderTop: "none",
        overflowY: "auto",
      }}>
      <Title title="配置预览" desc="即时查看视频配置效果"></Title>
      <div className="video-wrapper" id="video-wrapper-preview">
        <canvas
          ref={canvasRef}
          className="canvas-preview"
          style={{
            position: 'absolute',
            pointerEvents: 'none',
            zIndex: 1000,
            top: (640 - enumRatio(aspectRatio).h) / 2,
            left: 0,
            backgroundColor: 'transparent',
          }}
        />
        {loading ? (
          <div className="loading-wrapper">
            <IconLoading style={{color: "white", fontSize: 30}}/>
            <p>后台正在解析，请稍后</p>
          </div>
        ) : (
          <></>
        )}
        {
          <>
            <>
              {
                <Player
                  key={'player'}
                  isDisabled={false}
                  previewInfo={timeLine}
                  clipWatch={(id, config) => {
                    toIdAndConfigSetSetting(id, config);
                  }}
                  aspectRatio={mixCutDetailMsg?.aspect}
                  clipId={clipIdStore.getClipId()}
                  PlayerFunRef={playerRef}
                />
              }
            </>
          </>
        }
      </div>
      <div className="preview-select-wrapper">
        <div className={'column-select'} style={{marginRight: 42}}>
          <span className={'label'}>背景填充：</span>
          <Select
            placeholder="请选择"
            style={{width: 142}}
            onChange={(e) => {
              setBgSelect(e);
              background.enable_blur = e === 2;
              if (e === 1) {
                ConfigStore.global_settings.background.blur.radius = 0
              } else {
                ConfigStore.global_settings.background.blur.radius = 10
              }
            }}
            value={background.enable_blur ? 2 : 1}
          >
            {bgOptions.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </div>
        <div className={'column-select'}>
          <span className={'label'}>素材使用规则：</span>
          <Select
            placeholder="请选择"
            style={{width: 142}}
            onChange={(e) => {
              setBgSelect(e);
              general.allow_repeat = e === 1;
            }}
            value={general.allow_repeat ? 1 : 2}>
            {madiaOptions.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </div>
        <div className={'column-select'} style={{marginRight: 42}}>
          <span className={'label'}>生成数量：</span>
          <InputNumber
            placeholder="请输入产出数量"
            min={1}
            max={1000}
            value={QuickCutStore.outputCount}
            onChange={(e) => {
              QuickCutStore.outputCount = e;
            }}
            style={{ width: 140 }}
          />
        </div>
        <div className={'column-select'}>
            <span className={'label'}>开启智能原创增强算法：</span>
            <Switch style={{ marginTop: '5px' }} checked={QuickCutStore?.quickcutData?.obfuscate?.enabled} onChange={value=>QuickCutStore.quickcutData.obfuscate.enabled = value}></Switch>
            {/* {JSON.stringify(QuickCutStore.quickcutData)} */}
        </div>
      </div>
    </MixCutConfigWrapper>
  );
});

export default PreviewingVideo;
